<template>
    <div class="slide">

        <go-back />

        <div class="next" @click="next" v-if="nextStepEnabled">
            <img src="/assets/img/icon-arrow-right-blue.svg" />
        </div>

        <div class="slide-container">

            <div class="question bigger" v-if="personTwoExists">
                Tell me <span>your names</span>.
            </div>

            <div class="question bigger" v-if="!personTwoExists">
                Tell me <span>your name</span>.
            </div>

            <div class="answer answer-col">

                <div class="row">
                    <div class="col-md-6">
                        <v-text-field
                            label="Your name" v-model="personOneName"
                        ></v-text-field>
                    </div>
                </div>

                <div class="row" v-if="personTwoExists">
                    <div class="col-md-6">
                        <v-text-field
                            label="Your spouse name" v-model="personTwoName"
                        ></v-text-field>
                    </div>
                </div>

            </div>

        </div>

    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import GoBack from "./GoBack";
    export default {
        name: 'IndividualName',
        components: {
            GoBack
        },
        methods: {
            next() {
                if (this.personTwoExists) {
                    this.$router.push({ name: 'SpouseWorkingRetired' });
                } else {
                    if (this.personOneIsWorking) {
                        this.$router.push({ name: 'ExpectRetirement' });
                    } else {
                        this.$router.push({ name: 'IndividualAge' });
                    }
                }
            }
        },
        computed: {
            ...mapGetters('individuals', [
                'personOne',
                'personTwo',
                'personTwoExists',
                'personOneIsWorking'
            ]),
            personOneName: {
                get () {
                    return this.personOne.name
                },
                set (value) {
                    this.$store.commit('individuals/setPersonOneName', value);
                }
            },
            personTwoName: {
                get () {
                    if (this.personTwoExists) {
                        return this.personTwo.name
                    }
                    return '';
                },
                set (value) {
                    this.$store.commit('individuals/setPersonTwoName', value);
                }
            },
            nextStepEnabled() {
                return this.personTwoName !== '' && this.personOneName !== '' ||
                    this.personOneName !== '' && !this.personTwoExists;
            }
        },
    }
</script>
